import styled from 'styled-components';

const ReactionsContainer = styled.div`
  width: 100%;
  position: relative;
`;

export default {
  ReactionsContainer,
};
